import mixpanel from 'mixpanel-browser';
import urlMatcher from './url-matcher';
export const getEventName = ({ screen, action, }) => {
    if (!screen) {
        return action;
    }
    if (!action) {
        return screen;
    }
    return `${screen} - ${action}`;
};
const getDurationEventName = (eventName) => `${eventName} - Duration`;
const track = ({ screen, action, props, trackDuration = false, }) => {
    const eventName = getEventName({ screen, action });
    mixpanel === null || mixpanel === void 0 ? void 0 : mixpanel.track(eventName, props);
    if (trackDuration) {
        mixpanel === null || mixpanel === void 0 ? void 0 : mixpanel.time_event(getDurationEventName(eventName));
    }
};
const isBrowserCompatible = () => {
    const uaResult = /msie\s(\d+)/i.exec(navigator.userAgent);
    const isIE9 = ((!!window.ActiveXObject &&
        uaResult &&
        +uaResult[1]) ||
        NaN) === 9;
    // if the browser is IE9, do not call the mixpanel function
    return !isIE9;
};
const Mixpanel = {
    initialize: ({ token, disabled, superProps, urlToScreen }) => {
        if (isBrowserCompatible()) {
            mixpanel === null || mixpanel === void 0 ? void 0 : mixpanel.init(token);
            mixpanel === null || mixpanel === void 0 ? void 0 : mixpanel.register(superProps);
            if (disabled) {
                mixpanel === null || mixpanel === void 0 ? void 0 : mixpanel.disable();
            }
            if (urlToScreen) {
                urlMatcher.config(urlToScreen);
            }
        }
    },
    trackAction: ({ action, itemName, props = {}, screen, }) => isBrowserCompatible() &&
        track({
            screen: screen ||
                urlMatcher.match(window.location.pathname) ||
                'Unknown',
            action,
            props: Object.assign(Object.assign({}, props), { Item: itemName }),
            trackDuration: false,
        }),
    trackPageView: ({ screen, props, trackDuration = false, }) => isBrowserCompatible() &&
        track({ screen, action: 'Page View', props, trackDuration }),
    startTrackDuration: ({ eventName }) => isBrowserCompatible() &&
        (mixpanel === null || mixpanel === void 0 ? void 0 : mixpanel.time_event(getDurationEventName(eventName))),
    stopTrackDuration: ({ eventName, props, }) => isBrowserCompatible() &&
        (mixpanel === null || mixpanel === void 0 ? void 0 : mixpanel.track(getDurationEventName(eventName), props)),
    setUserID(trackingID) {
        if (isBrowserCompatible()) {
            mixpanel === null || mixpanel === void 0 ? void 0 : mixpanel.identify(trackingID);
            mixpanel === null || mixpanel === void 0 ? void 0 : mixpanel.people.set({ 'Consumer Hash': trackingID });
        }
    },
    registerSuperProperties(props) {
        if (isBrowserCompatible()) {
            mixpanel === null || mixpanel === void 0 ? void 0 : mixpanel.register(props);
        }
    },
    setUserProperties(props) {
        if (isBrowserCompatible()) {
            mixpanel === null || mixpanel === void 0 ? void 0 : mixpanel.people.set(props);
        }
    },
};
export default Mixpanel;
